import { Redirect } from 'expo-router'

/**
 * La raiz del grupo de pestanas no es una pantalla: es un desvio.
 *
 * ANTES DEVOLVIA `null`, y eso es una pantalla en blanco por construccion. No es
 * teorico: al volver atras desde la ficha de un carro, el router desmontaba el
 * stack de explorar y aterrizaba aca, asi que la app quedaba con la barra de
 * navegacion y NADA mas -- 491 nodos antes, 146 despues, sin un solo error de
 * consola y sin recuperarse nunca. Solo tocar la navegacion la revivia.
 *
 * Medido con Playwright: `[MOUNT] explore-layout DESMONTADO` al volver, y
 * ningun montaje despues.
 *
 * `href: null` en el layout de pestanas la esconde de la barra, pero no impide
 * que el router la elija. Una ruta alcanzable tiene que llevar a algun lado: si
 * alguien cae aca, va a explorar, que es la casa de la app.
 */
export default function TabsIndex() {
  return <Redirect href="/explore" />
}
